import { useModal } from '@shared/model/useModal';

export const useRemoveAppointmentsNoteModal = () => useModal('remove-appointment-note')